import {useEffect, useState} from "react";
import {Button, Input, Table} from "antd";
import {getInventory} from "../../api/Api";
import {CategoryType, UnitType} from "../../api/Constants";
import {fixedToDisplayUnit} from "../../util/unitutils";

export const InventorySelectWidget = ({onApiFail, refresh, onRefresh, onSelect, category, props}) => {
    const [searchVal, setSearchVal] = useState("");
    const [options, setOptions] = useState([]);
    const [inventory, setInventory] = useState([]);

    useEffect(() => {
        getInventory().then((x) => {
            const tableData = x.map((val, index) => {
                return {...val, key: val.id}
            });

            let filteredData = tableData;
            if (category) {
                filteredData = tableData.filter(row => {
                    return row.category === category
                });
            }
            setInventory(filteredData);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [refresh, category, onApiFail]);

    const selectInventory = (record) => () => {
        if (onSelect) {
            onSelect(record);
        }
    }


    const columns = [
        {
            title: "Name",
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku'
        },
        {
            title: 'Quantity Available',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record, index) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                if (record.unit === UnitType.Each) {
                    return displayQuantity
                } else {
                    return `${displayQuantity} ${UnitType.Label[record.unit]}`
                }
            }
        },
        {
            title: 'Select',
            dataIndex: 'id',
            key: 'select',
            render: (val, record) => {
                return <Button onClick={selectInventory(record)}>Select</Button>
            }
        }
    ]

    const onInputChange = (e) => {
        const val = e.target.value;
        setSearchVal(val);
        if (val.length >= 3) {
            const searchData = inventory.filter(row => {
                return row.name.toLowerCase().includes(val.toLowerCase());
            })
            setOptions(searchData);
        } else {
            setOptions([])
        }
    }

    const inputStyle = {
        width: 300
    }

    let placeholder = "Inventory";
    switch (category) {
        case CategoryType.Wholesale:
            placeholder = "Bulk Inventory";
            break;
        case "Packaged":
            placeholder = "Packaged Inventory";
            break;
        case CategoryType.Supplies:
            placeholder = "Supplies";
            break;
        default:
    }
    return <div>
        <Input style={inputStyle} placeholder={placeholder} value={searchVal} onChange={onInputChange} />
        { (options.length > 0) &&
        <Table dataSource={options} columns={columns} pagination={false} />
        }
    </div>
}